export default __webpack_public_path__ + "static/media/BrainBreak cards38.2d563466.png";